import './Currency.scss';
import Component from './Currency.js';
export default Component;
